import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import FloatingBox from '@spa/shared/components/Search/FloatingBox';
import { Wrapper as ListingsIndicator } from '@spa/shared/components/Unisystem/Button/styles';

export const FloatingBoxWrapper = styled(FloatingBox)`
  background-color: ${props => props.theme.colors.pearlWhite};
`;

export const FiltersContainer = styled.div`
  width: auto;
  position: relative;

  & > div:first-of-type {
    & > div:first-of-type {
      margin-top: 0;
    }
  }
`;

export const ClearFilters = styled.button`
  color: ${props => props.theme.clearButton.color};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(14)};
  transition: opacity 0.25s ease-in-out;

  ${mediaMin.smallBreakpoint`
    position: initial;
    float: right;
  `}

  &.disabled {
    opacity: 0;
  }
`;

export const ClearFiltersWrapper = styled.div`
  --innerPadding: -26px;
  --inlinePadding: 26px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% + var(--inlinePadding) * 2);
  margin-inline: var(--innerPadding);
  margin-block-end: var(--innerPadding);
  padding-inline: var(--inlinePadding);
  height: 60px;
  background: ${props => props.theme.colors.lightest};
  border-top: 1px solid ${props => props.theme.colors.shadyGray};
  position: sticky;
  bottom: 0;

  ${ListingsIndicator} {
    &:hover {
      background-color: ${props => props.theme.colors.uniBlue};
    }
  }

  button {
    font-family: IntervalNextReg, sans-serif;
  }
`;

export const StickyWrapper = styled.div`
  position: relative;
  height: 70px;

  .sticky-inner {
    width: 190px;
    opacity: 0;
  }

  &.sticky {
    .sticky-inner {
      position: fixed;
      top: 80px;
      left: auto;
      right: auto;
      z-index: 1;
      opacity: 1;
      transition: opacity 1s ease-out;
    }
  }
`;

export const UniresidencesWrapper = styled.div`
  margin-bottom: ${props => props.theme.space(5)};

  & > div:first-of-type {
    margin-bottom: ${props => props.theme.space(2)};
  }
`;
